export const COUNTRY_LIST = ['US', 'VN', 'CN']

// localization
export const LOCALIZATION_LIST = [
  { flag: 'US', lang: 'en-US' },
  // { flag: 'VN', lang: 'vi-VN' },
  // { flag: 'CN', lang: 'zh-CN' },
]
